export default "__VITE_ASSET__4_qf48vw__"